import React from "react";

import { StyledButtonContainer, StyledButtonContainerProps } from "./styles";

export const ButtonContainer: React.FC<StyledButtonContainerProps> = ({
  spaceDirection = "horizontal",
  align = "flex-start",
  children,
  ...rest
}) => {
  return (
    <StyledButtonContainer
      spaceDirection={spaceDirection}
      align={align}
      {...rest}
    >
      {children}
    </StyledButtonContainer>
  );
};
